module.exports = __webpack_public_path__ + "media/a3.5c517a6f.wav";